/**
 * USAGE EXAMPLE:
 *
 * ```
 * const storage = new LocalStorage();
 * storage.set('name', 'Olayemi');
 * storage.set('age', 25);
 *
 * console.log(storage.get('name'));
 * console.log(storage.get('age'));
 * ```
 */
export class LocalStorage {

    constructor() {
        this.storagePrefix = 'ls-boeckmann:';
    }

    set(key, value) {
        localStorage.setItem(this.keyName(key), JSON.stringify(value));
    }

    get(key) {
        const storedValue = localStorage.getItem(this.keyName(key));
        return storedValue ? JSON.parse(storedValue) : null;
    }

    has(key) {
        return localStorage.getItem(this.keyName(key)) !== null;
    }

    delete(key) {
        localStorage.removeItem(this.keyName(key));
    }

    keyName(key = '') {
        return this.storagePrefix + key;
    }
}

